<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { sanitizeUrl } from '@braintree/sanitize-url';
import { assetURL } from '../../utils/url';

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    methods: {
        sanitize(url) {
            return sanitizeUrl(url);
        },
    },
    // beforeMount() {
    //     this.getEstateList();
    // },
    data() {
        return {
            items: [],
            breakpoints: {
                700: {
                    direction: 'horizontal',
                    centeredSlides: false,
                    spaceBetween: 15,
                    step: 1,
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 3,
                },
            },
            banner1: `${assetURL}images/placeholder/thumbnail.png`,
            sub_banner1: `${assetURL}images/legacy-1.webp`,
            sub_banner2: `${assetURL}images/legacy-2.webp`,
            sub_banner3: `${assetURL}images/legacy-3.webp`,

            link1: sanitizeUrl(`${assetURL}estates/ortigas-center`),
            link2: sanitizeUrl(`${assetURL}estates/capitol-commons`),
            link3: sanitizeUrl(`${assetURL}estates/circulo-verde`),
            link4: sanitizeUrl(`${assetURL}estates/greenhills`),
            link5: sanitizeUrl(`${assetURL}estates/ortigas-east`),
        };
    },
};
</script>
<template>
    <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[65%_35%] tw-mt-32 tw-mb-28 lg:tw-mb-32 xl:tw-grid-cols-[60%_40%]"
    >
        <div class="tw-relative">
            <swiper
                :breakpoints="breakpoints"
                :centeredSlides="false"
                :slidesPerView="3"
                :spaceBetween="15"
                class="legacy-list__swiper"
            >
                <swiper-slide class="legacy-list__slide">
                    <div class="swiper-content">
                        <img :src="sub_banner1" class="swiper-image" />
                    </div>
                </swiper-slide>
                <swiper-slide class="legacy-list__slide">
                    <div class="swiper-content">
                        <img :src="sub_banner2" class="swiper-image" />
                    </div>
                </swiper-slide>
                <swiper-slide class="legacy-list__slide">
                    <div class="swiper-content">
                        <img :src="sub_banner3" class="swiper-image" />
                    </div>
                </swiper-slide>
            </swiper>
        </div>
        <div
            class="tw-pl-4 tw-pr-4 tw-w-full tw-pb-14 lg:tw-pl-5 xl:tw-pl-8 xl:tw-pr-8 xl:tw-pb-[0px] xxl:tw-pl-15 xxl:tw-pr-20 xxl:tw-w-[550px] tw-space-y-5 tw-mt-10 lg:tw-mt-0"
        >
            <div
                class="tw-text-darkGreen tw-leading-10 tw-text-[32px] md:tw-text-[32px] lg: xl:tw-text-[32px] tw-font-extrabold"
            >
                Our legacy
            </div>
            <div class="tw-text-darkTeal tw-text-[20px]">
                Our legacy includes some of the most sought-after real estate in
                Metro Manila such as the residential villages of Greenhills,
                Green Meadows, Valle Verde, and Wack Wack, the financial
                business district
                <a :href="this.sanitize(link1)">Ortigas Center</a>, and the
                well-loved shopping haven of Greenhills Mall, among others.
                Ortigas Land is currently developing mixed-use estates in the
                middle of Metro Manila, which are
                <a :href="this.sanitize(link2)">Capitol Commons</a>,
                <a :href="this.sanitize(link3)">Circulo Verde</a>,
                <a :href="this.sanitize(link4)">Greenhills Center</a>, and
                <a :href="this.sanitize(link5)">Ortigas East</a>.
            </div>
        </div>
    </div>
</template>

<style lang="scss">
#estatesList {
    width: 97vw;
    position: absolute;
    z-index: 6;
    bottom: 15vw;
}
.legacy-list__swiper {
    .swiper-wrapper {
        padding: 0px 0 40px 0;
    }
    .swiper-content {
        background-color: #f0f1f1;
        height: 50vw !important;
    }
    .swiper-heading,
    .swiper-footer {
        padding: 15px;
    }
    .swiper-footer {
        position: relative;
        min-height: 190px;
    }
    .swiper-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        max-width: 100%;
    }
    .legacy-list__slide:nth-of-type(even) {
        .swiper-content {
            margin-bottom: -40px;
            margin-top: 40px;
        }
    }

    .legacy-list__slide:nth-of-type(odd) {
        .swiper-content {
            margin-top: 0px;
        }
    }
}
.swiper__item-headerCategory {
    text-transform: uppercase;
    letter-spacing: 1.2px;
    margin-top: 8px;
}
.swiper__item-headerLink {
    text-decoration: none;
    display: block;
    float: right;
    position: absolute;
    right: 20px;
    bottom: 20px;
    &:hover,
    &:active,
    &:focus {
        color: #4a5846;
    }
}

@media (min-width: 992px) {
    .estates__listing-page {
        height: 710px;
        min-height: auto;
    }
    #estatesList {
        width: 80vw;
        bottom: 0vw;
    }
    .legacy-list__swiper {
        .swiper-content {
            height: 36vw !important;
        }
        .legacy-list__slide:nth-of-type(even) {
            .swiper-content {
                margin-top: 64px;
            }
        }
    }
}

@media (min-width: 1200px) {
    #estatesList {
        width: 85vw;
        margin: 0 0 0 48px;
    }
    .estates__listing-page {
        height: 710px;
        min-height: auto;
    }
    .legacy-list__swiper {
        .swiper-content {
            height: 28vw !important;
        }
    }
}
</style>
